import { useEffect } from 'react';
import { useRecipeFilterContext } from '@/context/recipeFilter';

export default () => {
  const [, { setPopstate }] = useRecipeFilterContext();
  useEffect(() => {
    // Event handler for history change
    window.onpopstate = e => {
      setPopstate(e.state);
    };
    return () => {
      window.onpopstate = null;
    };
  }, []);
};
